/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import MealEvent from '../../event/MealEvent'
import { MealState } from '../state/MealState'

class MealsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MealEvent.onSearch:
        if (!payload || !payload.meals) {
          return state
        }

        const meals = payload.meals.map(meal => new MealState(meal))
        return List(meals)
      default:
        return state
    }
  }
}

export default new MealsStore()
